import React, { useEffect, useState } from "react";
import useApi from "@/hooks/useApi";
import { UserStatusType, StatusContext } from "@velaro/velaro-component-lib";

export default function StatusProvider(props: { children: React.ReactNode }) {
  const [state, setState] = useState<UserStatusType>("Unavailable");
  const api = useApi();

  useEffect(() => {
    async function fetchStatus() {
      try {
        const resp = await api.messaging.get("UserStatus");
        if (resp.ok) {
          const data = await resp.json();
          setState(data.status ?? "Unavailable");
        }
      } catch {
        // keep default Unavailable
      }
    }

    fetchStatus();
  }, [api.messaging]);

  function setStatus(status: UserStatusType) {
    setState(status);
    api.messaging.post("UserStatus", { status });
  }

  return (
    <StatusContext.Provider value={{ status: state, setStatus }}>
      {props.children}
    </StatusContext.Provider>
  );
}
